import React, {useState} from 'react';
import {
    Box,
    Flex, FormControl, IconButton,
    Input,
    InputGroup,
    InputRightElement,
    Link,
    SimpleGrid, Spinner,
    Stack,
    Text,
} from '@chakra-ui/react';
import RightAnchorImg from '../../assets/images/right-anchor.svg';
import FooterContainer from './container';
import linksOption, {socialMediaOption} from '../../constants/links';
import {Link as RouterLink} from 'react-router-dom';
import axios from "axios";

const addressOptions = [
    {
        title: 'Silicon Valley',
        address: '3340 Hillview Avenue, <br/> Palo Alto, California 94304',
        phone: '650.561.9580',
        timeZone: 'America/Los_Angeles'
    },
    {
        title: 'New York',
        address: '7 Bryant Park, 23rd Floor<br />New York, NY 10018',
        phone: '212.444.4100',
        timeZone: 'America/New_York'
    }
];

const RightAnchorSvg = () => {
    return <img src={RightAnchorImg} alt="signup to newsletter"/>;
};

const getFormattedTimesForLocations = (options) => {
    return options.map((opt) => {
        const time = new Date(new Date().toLocaleString("en-US", {timeZone: opt.timeZone}));
        const formattedTime = time.toLocaleString('en-US', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        })
        return {
            ...opt,
            formattedTime
        }
    })
}

let footerInterval = null;

const Footer = () => {
    const [submitted, setSubmitted] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [locations, setLocations] = useState(getFormattedTimesForLocations(addressOptions))

    if(!footerInterval){
        // console.log('about to set interval on footer');
        footerInterval = setInterval(() => {
            setLocations(getFormattedTimesForLocations(addressOptions))
        }, 10 * 1000)
    }

    return (
        <>
            <FooterContainer>
                <Stack
                    direction={{base: 'column-reverse', lg: 'row'}}
                    justify="space-between"
                    textAlign="left"
                >
                    <SimpleGrid
                        columns={[1, 3]}
                        order={[1, 'unset']}
                        gap={['40px', '127px']}
                        width={{base: 'full', lg: 'auto'}}
                        mb={['60px', 0]}
                    >
                        {addressOptions.map((item, idx) => {
                            const time = new Date(new Date().toLocaleString("en-US", {timeZone: item.timeZone}));
                            const formattedTime = time.toLocaleString('en-US', {
                                hour: 'numeric',
                                minute: 'numeric',
                                hour12: true
                            })
                            return (
                                <Box maxW={'300'} key={idx}>
                                    <Text
                                        textColor={'white'}
                                        fontSize={'md'}
                                        fontWeight={'semibold'}
                                        lineHeight={'6'}
                                    >
                                        {item.title}
                                    </Text>
                                    <Text
                                        textColor={'white'}
                                        fontSize={'md'}
                                        fontWeight={'semibold'}
                                        lineHeight={'6'}
                                    >
                                        {formattedTime}
                                    </Text>
                                    <Text
                                        textColor={'white'}
                                        fontSize={'md'}
                                        fontWeight={'light'}
                                        lineHeight={'6'}
                                        dangerouslySetInnerHTML={{
                                            __html: item.address,
                                        }}
                                    />
                                    <Box mt={'5'}>
                                        <Text
                                            textColor={'whiteAlpha.600'}
                                            fontSize={'xs'}
                                            fontWeight={'light'}
                                            lineHeight={'10px'}
                                            textTransform={'uppercase'}
                                        >
                                            phone
                                        </Text>
                                        <Link
                                            as={RouterLink}
                                            to={`tel:${item.phone}`}
                                            textColor={'white'}
                                            fontSize={'md'}
                                            fontWeight={'light'}
                                            lineHeight={'6'}
                                        >
                                            {item.phone}
                                        </Link>
                                    </Box>
                                </Box>
                            )
                        })}
                    </SimpleGrid>
                    <Stack
                        spacing={0}
                        sx={{
                            '& a:not(:last-child)': {
                                mb: '1.25rem !important',
                            },
                            mr: ['0.7rem !important', '3.7rem !important'],
                        }}
                        minWidth={{base: "auto", md: "254px"}}
                        direction={'column'}
                    >
                        {linksOption.map((item, idx) => (
                            <Link
                                fontWeight={'semibold'}
                                lineHeight={'3rem'}
                                letterSpacing={'-1px'}
                                fontSize={'5xl'}
                                key={idx}
                                to={item.external ? undefined : item.href}
                                href={item.external ? item.href : undefined}
                                isExternal={item.external}
                                as={item.external ? undefined : RouterLink}
                            >
                                {item.title}
                            </Link>
                        ))}
                    </Stack>
                </Stack>
                <Box mt={['60px', 0]} mb={['5.25rem', '3.75rem']} textAlign="left">
                    
                </Box>
                <Flex
                    justifyContent={'space-between'}
                    flexDirection={['row-reverse', 'row']}
                    alignItems={'center'}
                >
                    <Text color={'white'} lineHeight={'6'} fontSize={'md'}>
                        © 2022 Venrock
                    </Text>
                    <Box
                        display={'flex'}
                        flexDirection={'column'}
                        width={['auto', '256px']}
                        textAlign={'left'}
                        mr={['0', '3.7rem']}
                    >
                        <Text
                            textColor={'whiteAlpha.600'}
                            fontSize={'xs'}
                            fontWeight={'semibold'}
                            lineHeight={'10px'}
                            textTransform={'uppercase'}
                            mb={'2'}
                        >
                            follow us
                        </Text>
                        {socialMediaOption.map((item, idx, key) => {
                            return (
                                <Link
                                    href={item.href}
                                    textColor={'white'}
                                    fontSize={'md'}
                                    fontWeight={'semibold'}
                                    lineHeight={'6'}
                                    key={idx}
                                >
                                    {item.title}
                                </Link>
                            );
                        })}
                        
                    </Box>
                </Flex>
            </FooterContainer>
        </>
    );
};

export default Footer;

Footer.displayName = 'companies-overview__footer';
